// Student Assessments rebuild (Mudassir, Sep-15). All enums are integers on the wire.
// Academic year / semester labels live in src/Common/academicYear.js (reused).

// Assessment workflow status (Personality, Career Path, University Recommendation).
export const AssessmentWorkflowStatus = {
  Unknown: 0,
  Submitted: 1,
  Processing: 2,
  AwaitingCounselorReview: 3,
  Approved: 4,
  ReturnedForRevision: 5,
  ResultUnavailable: 6, // AI prep failed; counselor may review manually (soft wording)
}

export const ASSESSMENT_WORKFLOW_STATUS_LABELS = {
  0: 'Not started',
  1: 'Submitted',
  2: 'Processing',
  3: 'Awaiting counselor review',
  4: 'Approved',
  5: 'Returned for revision',
  6: 'Awaiting counselor review', // manual review; never surface the AI-error detail to users
}

export const assessmentWorkflowStatusLabel = (v) =>
  v === null || v === undefined || v === ''
    ? ''
    : ASSESSMENT_WORKFLOW_STATUS_LABELS[Number(v)] || ''

// AntD Tag colour per workflow status.
export const assessmentStatusColor = (v) =>
  ({
    1: 'blue',
    2: 'gold',
    3: 'orange',
    4: 'green',
    5: 'red',
    6: 'orange',
  }[Number(v)] || 'default')

// Answer type.
export const AnswerType = { Unknown: 0, SingleChoice: 1, MultiChoice: 2 }

// DISC type.
export const DiscType = { Unknown: 0, D: 1, I: 2, S: 3, C: 4 }
export const DISC_CODE = { 0: '', 1: 'D', 2: 'I', 3: 'S', 4: 'C' }
export const discCode = (v) => (v === null || v === undefined ? '' : DISC_CODE[Number(v)] || '')

// Behavior score (1-4).
export const BehaviorScore = {
  LittleOrNoEffort: 1,
  SomeEffort: 2,
  GoodEffort: 3,
  OutstandingEffort: 4,
}
export const BEHAVIOR_SCORE_LABELS = {
  1: 'Little or no effort',
  2: 'Some effort',
  3: 'Good effort',
  4: 'Outstanding effort',
}
export const behaviorScoreLabel = (v) =>
  v === null || v === undefined || v === '' ? '' : BEHAVIOR_SCORE_LABELS[Number(v)] || ''

// The seven behavior support flags recorded on an agreement.
export const BEHAVIOR_FLAGS = [
  { key: 'communication', label: 'Communication' },
  { key: 'urgentAlerts', label: 'Urgent alerts' },
  { key: 'positiveReinforcement', label: 'Positive reinforcement' },
  { key: 'incentives', label: 'Incentives' },
  { key: 'clearConsequences', label: 'Clear consequences' },
  { key: 'specificGoals', label: 'Specific goals' },
  { key: 'goalReassessment', label: 'Goal reassessment' },
]
